// extracted by mini-css-extract-plugin
export default {"Mango":"Mango_Mango__jGx-c"};